const SummaryIcon = ({color="#01917E"}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={27} height={54} fill="none">
    <path
      fill={color}
      d="M26.834 22.814V.334H.167v22.48c0 .933.48 1.813 1.307 2.293L12.62 31.8l-2.64 6.24-9.093.773 6.907 5.974-2.107 8.88 7.813-4.72 7.814 4.72-2.08-8.88 6.906-5.974-9.093-.773-2.64-6.24 11.147-6.693a2.64 2.64 0 0 0 1.28-2.293Zm-10.667 4.8-2.667 1.6-2.666-1.6V3h5.333v24.613Z"
    />
  </svg>
);
export default SummaryIcon;
